import styled from 'styled-components';
import pattern from '../../../assets/pattern.svg';
import { FormCheckboxGroup } from '../../FormCheckbox/styles';

export const CheckboxGroup = styled(FormCheckboxGroup)`
  display: block;
  width: 100%;
  padding-bottom: 1rem;
`;

export const WizardWelcome = styled.div`
  width: 42rem;
  height: auto;
  max-height: 90vh;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: stretch;
`;

export const Sider1 = styled.div`
  width: 2.5rem;
  height: 100%;
  min-height: 40.44rem;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
  padding: 1.5rem;
  background-color: #732fd2;
  background-image: url(${pattern});
  flex-shrink: 0;
`;

export const Wrapper = styled.div`
  width: 100%;
  height: auto;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.5rem;
  background-color: #ffffff;
  box-shadow: 1.75rem 0.5rem rgba(0, 0, 0, 0.05), 1rem rgba(0, 0, 0, 0.08),
    0.38rem -0.25rem rgba(0, 0, 0, 0.12);
  overflow-y: auto;
  flex: 1;
`;

export const PageHeader = styled.div`
  justify-content: space-between;
  width: 100%;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
`;

export const TopBar = styled.div`
  width: 100%;
  display: inline-flex;
  gap: 1rem;
  align-items: center;
`;

export const Fields = styled.div`
  width: 100%;
  max-height: 25rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 0.5rem;
`;

export const Row01 = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 1.25rem;
  row-gap: 0.75rem;

  label {
    margin-left: 0px !important;
    white-space: normal;
    word-wrap: break-word;
    line-height: 1.3;
    font-size: 0.875rem;
  }
`;

export const Column01 = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Column02 = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Row02 = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 1.25rem;
  row-gap: 0.75rem;
`;

export const Column011 = styled.div`
  width: 100%;
  display: inline-flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Column021 = styled.div`
  width: 100%;
  height: 25rem;
  display: inline-flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Row021 = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 1.25rem;
  row-gap: 0.75rem;
  min-height: auto;
`;

export const Column012 = styled.div`
  width: 100%;
  display: inline-flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Column022 = styled.div`
  width: 100%;
  display: inline-flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const ActionBar = styled.div`
  width: 100%;
  display: inline-flex;
  gap: 0.5rem;
  justify-content: flex-end;
  align-items: center;
  margin-top: auto;
  flex-shrink: 0;
`;

export const RequiredFieldsHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 1rem;
`;

export const HelpToggle = styled.button`
  background: none;
  border: none;
  color: #732fd2;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem;
  border-radius: 50%;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(115, 47, 210, 0.1);
  }
`;
